import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/sf-composite-bonding/hero";
import WhatAndWhy from "../components/sf-composite-bonding/what-and-why";
import Process from "../components/sf-composite-bonding/process";
import AfterCare from "../components/sf-composite-bonding/aftercare";
import Benifits from "../components/sf-composite-bonding/benefits";
import CTA from "../components/sf-composite-bonding/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionSF from "../components/sf-composite-bonding/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Smile Fast Composite Bonding",
    url: "https://www.regent-dental.co.uk/smile-fast-composite-bonding",
    name: "Smile Fast Composite Bonding in Ilkley | Regent Dental",
    description:
      "Smile Fast composite bonding at Regent Dental is a quick and effective way to improve the appearance of your smile with minimal invasiveness.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What are porcelain veneers?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Porcelain veneers are thin, custom-made shells that are carefully fitted over the front surface of your teeth to enhance their appearance, giving you a beautifully natural and confident smile.",
        },
      },
      {
        "@type": "Question",
        name: "What concerns can veneers fix?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Veneers are a wonderful solution for chipped, discoloured, uneven, gappy or slightly misaligned teeth. They can transform your smile with minimal preparation.",
        },
      },
      {
        "@type": "Question",
        name: "What is the process for getting veneers?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We’ll start with a detailed consultation to understand your goals. Then, we’ll carefully prepare your teeth, take impressions, and fit your bespoke veneers once they’re ready - all with your comfort in mind.",
        },
      },
      {
        "@type": "Question",
        name: "How long do porcelain veneers last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "With good care, porcelain veneers can last 10–15 years or even longer. We’ll give you all the advice you need to look after them and keep your smile shining.",
        },
      },
      {
        "@type": "Question",
        name: "Will my veneers look natural?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Absolutely. At Regent Dental, we pride ourselves on creating veneers that look beautifully natural, carefully matching the colour, shape, and size to suit your face and smile.",
        },
      },
      {
        "@type": "Question",
        name: "Are veneers permanent?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Because a small amount of enamel is removed during preparation, veneers are considered a permanent treatment. We’ll make sure you feel fully informed and comfortable before going ahead.",
        },
      },
      {
        "@type": "Question",
        name: "Does it hurt to have veneers fitted?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The process is gentle and should not be painful. We’ll use a local anaesthetic if needed to keep you completely comfortable during the preparation stage.",
        },
      },
      {
        "@type": "Question",
        name: "Can I have veneers on just one or two teeth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, you can. Whether you’d like to improve just a single tooth or achieve a full smile makeover, we’ll create a treatment plan that’s tailored perfectly to you.",
        },
      },
      {
        "@type": "Question",
        name: "How do I look after my veneers?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Caring for veneers is very similar to caring for natural teeth – brush twice daily, floss regularly, attend your dental check-ups, and avoid using your teeth as tools!",
        },
      },
      {
        "@type": "Question",
        name: "Are veneers right for me?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "If you’re dreaming of a straighter, whiter, or more even smile, veneers could be a wonderful option. We’d love to invite you in for a consultation to chat through what’s possible.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>
          Composite Bonding in Ilkley, West Yorkshire | Regent Dental
        </title>
        <meta
          name="description"
          content="Get a confident smile quickly with composite bonding in West Yorkshire. SmileFast at Regent Dental improves your smile's appearance effectively and affordably."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/smile-fast-composite-bonding"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <Benifits />
      <QuestionSF />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
